import { Typography } from "@mui/material";
import { Divider } from "@mantine/core";
import ProductDetailsPrimary from "./ProductDetailsPrimary";
import RenderSvg from "../renderSvg/RenderSvg";
import "./OrderDetailsPrimary.css";

interface OrderDetail {
  orderDetails: Record<string, any>[];
  skuCodeSortOrder: string []
}

const OrderDetailsPrimary = (props: OrderDetail) => {
  const sortedOrderDetails: any [] = [...(props.orderDetails ?? [])];

  sortedOrderDetails?.sort((a, b) => {
    const indexA = props?.skuCodeSortOrder.indexOf(a.skuCode);
    const indexB = props?.skuCodeSortOrder.indexOf(b.skuCode);
    return indexA - indexB;
});

  return (
    <div className="order_details_container">
      {
        <>
          <div className="sub_header">
            <div style={{ display: "flex" }}>
              <div className="confirmed_order_icon">
                <RenderSvg name="orderConfirmedIcon" />
              </div>
              <Typography sx={{ fontWeight: 500, fontSize: "16px !important", color: "#227C9D" }}>
                Order Details
              </Typography>
            </div>
          </div>

          <Divider sx={{ height: "14px" }} color="#f1f1f1" />

          <div className="product_details_list">
            {sortedOrderDetails?.map((product) => {
              return <ProductDetailsPrimary product={product} />;
            })}
          </div>
        </>
      }
    </div>
  );
};

export default OrderDetailsPrimary;
